import Configuration from "./config";

export class Cache
{
	static load( name, defaultValue = null )
	{
		const value = localStorage.getItem( name );
		
		// Wert ist noch nicht gecacht
		if ( value === null )
		{
			return defaultValue;
		}
		
		let parsedValue;
		
		try
		{
			parsedValue = JSON.parse( value );
		}
		catch ( e )
		{
			localStorage.removeItem( name );
			return defaultValue;
		}
		
		// Gecachter Wert ist nicht mehr gültig
		if ( typeof parsedValue !== "object" || parsedValue.cacheVersion !== Configuration.version )
		{
			localStorage.removeItem( name );
			return defaultValue;
		}
		
		return parsedValue.value;
	}
	
	static save( name, value )
	{
		localStorage.setItem( name, JSON.stringify( { cacheVersion: Configuration.version, value } ) );
	}
	
	static remove( name )
	{
		localStorage.removeItem( name );
	}
}

export class Setting
{
	// Beim Laden von Settings keine gespeicherten Werte invalidieren
	static load( name, defaultValue = null )
	{
		const value = localStorage.getItem( name );
		
		// Wert ist noch nicht gecacht
		if ( value === null )
		{
			return defaultValue;
		}
		
		let parsedValue;
		
		try
		{
			parsedValue = JSON.parse( value );
		}
		catch ( e )
		{
			localStorage.removeItem( name );
			return defaultValue;
		}
		
		return parsedValue;
	}
	
	static save( name, value )
	{
		localStorage.setItem( name, JSON.stringify( value ) );
	}
	
	static remove( name )
	{
		localStorage.removeItem( name );
	}
}
